import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MatCard, MatCardContent} from '@angular/material/card';
import {Store} from '@ngrx/store';
import {RegistrationActions} from '@store/registration/registration.actions';
import {RegistrationSelectors} from '@store/registration/registration.selectors';
import {NgOptimizedImage} from '@angular/common';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';

@Component({
  selector: 'px-registration-verify-email-expired',
  host: {
    class: 'flex flex-row justify-center md:justify-between lg:pl-10 lg:pr-20'
  },
  templateUrl: './registration-verify-email-expired.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCardContent, MatCard, NgOptimizedImage, FilledButtonComponent]
})
export class RegistrationVerifyEmailExpiredComponent {
  public readonly store = inject(Store);
  public readonly selectors = RegistrationSelectors.Registration;

  public onClickResend() {
    this.store.dispatch(RegistrationActions.requestVerificationEmail());
  }
}
